export const FINISH_SURVEY = 'FINISH_SURVEY'

export const SUBMIT_RECAPTCHA = 'SUBMIT_RECAPTCHA'

export const OPT_IN_RECAPTCHA_VALIDATION_FAILED =
  'OPT_IN_RECAPTCHA_VALIDATION_FAILED'
